import { useTheme } from '@mui/material/styles'

export const useStyles = () => {
  const theme = useTheme()

  return {
    rootPaper: {
      padding: theme.spacing(4, 4, 1, 4),
      margin: theme.spacing(0),
      backgroundColor: '#ffffff'
    },
    sectionTitle: {
      fontWeight: 600,
      marginBottom: theme.spacing(1)
    },
    infoBox: {
      backgroundColor: '#fafafa',
      border: '1px solid #e0e0e0',
      borderRadius: 4,
      padding: theme.spacing(2),
      marginBottom: theme.spacing(4),
      display: 'flex',
      alignItems: 'center',
      color: '#555'
    },
    infoIcon: {
      marginRight: theme.spacing(2),
      color: '#757575'
    },
    controlsContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing(2)
    },
    tableContainer: {
      border: '1px solid #e0e0e0',
      borderRadius: 4,
      marginBottom: theme.spacing(2)
    },
    tableHeadCell: {
      fontWeight: 'bold',
      color: '#555',
      backgroundColor: '#fcfcfc',
      borderBottom: '2px solid #f0f0f0',
      padding: '8px 6px'
    },
    tableBodyCell: {
      padding: '4px 6px'
    },
    previewBox: {
      backgroundColor: '#f5f7f9',
      padding: theme.spacing(3),
      borderRadius: 4,
      border: '1px dashed #ced4da',
      marginBottom: theme.spacing(2)
    },
    actionButton: {
      color: '#757575',
      padding: 6
    },
    footer: {
      marginTop: theme.spacing(5),
      display: 'flex',
      justifyContent: 'flex-end',
      borderTop: '1px solid #eee',
      paddingTop: theme.spacing(3)
    }
  } as const
}
